import { z } from 'zod';

import { fullNameSchema, transformFullNameSchema } from 'components/shared/types/FullNameSchema';

export const clientSchema = z
  .object({
    id: z.number(),
    phone: z.string(),
    email: z.string().nullable(),
    ...fullNameSchema.shape,
  })
  .transform((raw) => {
    return {
      id: raw.id,
      phone: raw.phone,
      email: raw.email,
      ...transformFullNameSchema.parse(raw),
    };
  });

export type ClientEntityApi = z.input<typeof clientSchema>;

export type ClientEntity = z.infer<typeof clientSchema>;
